// SpecializedScrapPage.js
import React from 'react';
import { Box, Typography, Container, Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
// Removed import of PageLayout as it is no longer used

const SpecializedScrapPage = () => {
  // Define breadcrumbs directly within the component
  const breadcrumbs = [
    { name: 'Home', path: '/' },
    { name: 'Metals & Materials', path: '/metals-materials' },
    { name: 'Specialized Scrap', path: '/metals-materials/specialized-scrap' },
  ];

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', p: 2 }}>
      <Container sx={{ py: { xs: 4, md: 6 }, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
        {/* Breadcrumbs */}
        <Box sx={{ mb: { xs: 2, md: 4 }, px: { xs: 2, md: 0 } }}>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            {breadcrumbs.map((crumb, index) => (
              crumb.path ? (
                <MuiLink component={RouterLink} to={crumb.path} key={index} underline="hover" color="text.secondary" variant="body2">
                  {crumb.name}
                </MuiLink>
              ) : (
                <Typography key={index} color="text.primary" variant="body2">{crumb.name}</Typography>
              )
            ))}
          </Breadcrumbs>
        </Box>

        <Typography variant="h3" align="center" fontWeight={700} sx={{ mb: { xs: 4, md: 6 }, color: 'text.primary' }}>
          Specialized Scrap
        </Typography>

        <Typography variant="body1" paragraph>
          Specialized scrap refers to unique or high-value materials that require specific handling and processing due to their composition, rarity, or hazardous nature. This can include precious metals, electronic waste (e-waste), and certain industrial residues.
        </Typography>
        <Typography variant="body1" paragraph>
          Our platform connects specialized buyers and sellers, ensuring responsible and compliant recycling of these complex materials.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          *Examples: Gold, Silver, Platinum, Palladium, Circuit Boards, Catalytic Converters.*
        </Typography>
      </Container>
    </Box>
  );
};

export default SpecializedScrapPage;
